import http from 'http'
// import filter from 'src/utils/filter'
import server from 'src/utils/server'

export const getContractPlanEntries = (params) => {
  return http.get(server.url_to('contract_plans/') + params.contract_plan_id + '/entries/')
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const newContractPlanEntry = (params) => {
  return http.post(server.url_to('contract_plans/') + params.contract_plan_id + '/entries/', params)
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const updateContractPlanEntry = (params) => {
  return http.post(server.url_to('contract_plans/') + params.contract_plan_id + '/entries/' + params.id, params)
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}



// WEBPACK FOOTER //
// ./src/app/pages/contract_plan_entries/services.js